import $axios from "../../api/axios";

function getLstApi({ params, callback }) {
  $axios
    .get(`/api/orders/purchase/0/9999999999/${params.page}/${params.pageSize}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getPropertyDtlApi({ params, callback }) {
  $axios
    .get(`/api/orders/purchase/${params}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getPdfApi({ params, callback }) {
  $axios
    .get(`/api/house/order/pdf/${params.id}/${params.roomId}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getLstApi,
  getPropertyDtlApi,
  getPdfApi
};



// WEBPACK FOOTER //
// ./src/api/account/purchase.js